import { ApiClient } from "@modules/core/api/client/apiClient"
import { BoxPromoCodeApiGateway } from "@modules/promoCode/services/boxPromoCodeApi.gateway"
import { BoxPromoCodeDto } from "@modules/promoCode/services/boxPromoCodeDto"
import { BoxPromoCodeDraft } from "@modules/promoCode/types/boxPromoCodeTypes"

export class BoxPromoCodeApi implements BoxPromoCodeApiGateway {
  private baseUrl = "/box/promo-codes"

  constructor(private api: ApiClient) {}

  async getBoxPromoCodes(expired: boolean): Promise<BoxPromoCodeDto[]> {
    const result = await this.api.get<BoxPromoCodeDto[]>(`${this.baseUrl}`, { params: { expired } })
    return result.data
  }

  async createBoxPromoCode(promoCodeDraft: BoxPromoCodeDraft) {
    const resultDto = await this.api.post<BoxPromoCodeDto>(`${this.baseUrl}`, promoCodeDraft)
    return resultDto.data
  }

  async updateBoxPromoCode(id: string, promoCodeDraft: BoxPromoCodeDraft) {
    await this.api.put(`${this.baseUrl}/${id}`, promoCodeDraft)
  }

  async deleteBoxPromoCode(id: string) {
    await this.api.delete(`${this.baseUrl}/${id}`)
  }
}
